var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColumns = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 32,
  viewBox: "0 0 40 32",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 0C0.895431 0 0 0.895431 0 2V30C0 31.1046 0.895431 32 2 32H38C39.1046 32 40 31.1046 40 30V2C40 0.895431 39.1046 0 38 0H2ZM2 1C1.44772 1 1 1.44772 1 2V30C1 30.5523 1.44772 31 2 31H38C38.5523 31 39 30.5523 39 30V2C39 1.44772 38.5523 1 38 1H2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 2.5C11 2.22386 11.2239 2 11.5 2H37.5C37.7761 2 38 2.22386 38 2.5V5.5C38 5.77614 37.7761 6 37.5 6H11.5C11.2239 6 11 5.77614 11 5.5V2.5Z",
  fill: "currentColor"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 3,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 3,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 3,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 7,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 7,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 7,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 7,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 11,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 11,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 11,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 11,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 15,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 15,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 15,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 15,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 19,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 19,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 19,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 19,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 23,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 23,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 23,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 23,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 27,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 27,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 27,
  width: 7,
  height: 2,
  rx: 0.5
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 27,
  width: 7,
  height: 2,
  rx: 0.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgColumns);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/columns.0cc4deac6b7fb7b2e2fc1d178c389034.svg";